import axios from 'axios'
import * as vars from './vars';

export function createNotifications (createNotificationsRequest, jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/admin/CreateNotifications',
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data : createNotificationsRequest
    })
}
